import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as project from '../../lib/api/project';

const [
  LIST_ORDER_SHEET_SENT,
  LIST_ORDER_SHEET_SENT_SUCCESS,
  LIST_ORDER_SHEET_SENT_FAILURE,
] = createRequestActionTypes('project/LIST_ORDER_SHEET_SENT');

export const listOrderSheetSents = createAction(
  LIST_ORDER_SHEET_SENT,
  (id) => id,
);
const listOrderSheetSentsSaga = createRequestSaga(
  LIST_ORDER_SHEET_SENT,
  project.getOrderSheets,
);

const UNLOAD_ORDERSHEET = 'project/UNLOAD_ORDERSHEET';
export const unloadOrderSheets = createAction(UNLOAD_ORDERSHEET);

export function* orderSheetSentsSaga() {
  yield takeLatest(LIST_ORDER_SHEET_SENT, listOrderSheetSentsSaga);
}

const initialState = {
  orderSheets: null,
  error: null,
};

const orderSheetSents = handleActions(
  {
    [LIST_ORDER_SHEET_SENT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      orderSheets: data.list.map((ordersheet) => ({
        id: ordersheet.spoUuid,
        spoUuid: ordersheet.spoUuid,
        prjUuid: ordersheet.prjUuid,
        orderSheetNo: ordersheet.orderSheetNo,
        sellPartnerUuid: ordersheet.sellPartnerUuid,
        sellPartnerNm: ordersheet.sellPartnerNm,
        sheetCrtDate: ordersheet.sheetCrtDate,
        sheetUsrNm: ordersheet.sheetUsrNm,
        sheetUsrTel: ordersheet.sheetUsrTel,
        sheetCstNm: ordersheet.sheetCstNm,
        sheetPayCond: ordersheet.sheetPayCond,
        sheetPeriod: ordersheet.sheetPeriod,
        sheetDesc: ordersheet.sheetDesc,
        sheetTotal: ordersheet.sheetTotal,
        useYn: ordersheet.useYn,
        crtUsr: ordersheet.crtUsr,
        crtNm: ordersheet.crtNm,
        crtDt: ordersheet.crtDt,
        cngUsr: ordersheet.cngUsr,
        cngNm: ordersheet.cngNm,
        cngDt: ordersheet.cngDt,
      })),
      error: null,
    }),
    [LIST_ORDER_SHEET_SENT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_ORDERSHEET]: () => initialState,
  },
  initialState,
);

export default orderSheetSents;
